import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative'
  },

  iconRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: 4
  },

  menu: {
    border: '1px solid #E6EAEC',
    borderRadius: '6px',
    boxSizing: 'border-box',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.04)',
    minWidth: '10rem',
    padding: '0.5rem',
    background: '#FFFFFF',
    overflow: 'hidden auto'
  },

  menuRoot: {
    display: 'flex',
    flexDirection: 'column'
  },

  count: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    transform: 'translateX(50%) translateY(-50%)'
  },

  emails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem'
  }
}))

export default useStyles
